import { add, isFuture, startOfDay, sub } from 'date-fns'
import { useEffect, useState } from 'react'

import { DateRangeValue } from '../../../components/DateRangePicker/DateRangePicker'
import { valueIsBetween } from '../../../helpers/valueIsBetween'
import { TableRowUpdateImpact } from '../../update-impacts/types/TableRowUpdateImpact'

/**
 * Date range state for the game update performance chart. The range is (re)initialized to
 * release date ± 3 months only when the selected update changes and falls outside the current
 * range. Manual date range selections are always preserved (GR-1233).
 *
 * The effect is keyed on the update's id and release date instead of the impact object itself
 * since the impact objects are recreated on every render of the update history hooks.
 */
export const useUpdateImpactDateRange = (selectedUpdateImpact?: TableRowUpdateImpact) => {
  const [dateRange, setDateRange] = useState<DateRangeValue | undefined>()
  const impactId = selectedUpdateImpact?.id
  const releaseDate = selectedUpdateImpact?.releaseDate

  useEffect(() => {
    if (!impactId || releaseDate === undefined) return

    const gameReleaseDate = new Date(releaseDate)

    setDateRange((currentDateRange) => {
      if (currentDateRange?.fromDate && currentDateRange?.toDate && valueIsBetween(gameReleaseDate, currentDateRange.fromDate, currentDateRange.toDate)) {
        return currentDateRange
      }

      const fromDate = startOfDay(sub(gameReleaseDate, { months: 3 }))
      const toDate = isFuture(add(gameReleaseDate, { months: 3 })) ? startOfDay(new Date()) : startOfDay(add(gameReleaseDate, { months: 3 }))

      return { fromDate, toDate }
    })
  }, [impactId, releaseDate])

  return { dateRange, setDateRange }
}
